import Header from "../../components/header";
import LeftMenu from "../../components/left-menu";
import NewBookingPopUp from '../../components/NewBookingPopUp';
import TamuBooking from '../../components/TamuBooking';
import Grid from '@mui/material/Grid';
import "./style.css";
import React, {Component} from 'react';
import axios from "axios";
import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField'; 
import Button from '@mui/material/Button';
import {read} from "./api.js";
import {readEmpty} from "./apiEmpty.js";
import {useNavigate} from "react-router-dom";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import { endOfDecadeWithOptions } from "date-fns/fp";
import { editableInputTypes } from "@testing-library/user-event/dist/utils";
import { Select, MenuItem, Typography } from '@mui/material';
import { purple } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import { Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from '@mui/material'
import moment from "moment";
export default function CreatePost(){

    const moment = require('moment');

    const [Caption,setCaption] = useState("")
    const [skip, setSkip] = useState(0)
    const [posts, setPosts] = useState([])
    const [isEnd,setIsEnd] = useState("loading..")
    const navigate = useNavigate();
    const [query,setQuery] = useState("")
    const [previewVisibility, setPreviewVisibility] = useState(false)
    const [loadVisibility, setLoadVisibility] = useState(false)
    const [currPreview,setCurrPreview] = useState("none")
    const [categorias, setCategorias] = useState([]);
    const [address1,setAddress1] = useState("semua")
    const [alamatStatus,setAlamatStatus] = useState("");
    const [alamatMessage, setAlamatMessage] = useState("");
    const getCategorias = async () => {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/addressOptions`,{
        }).then(response=>{
          setCategorias(response.data.pilihanAlamat);
      });
    }
    useEffect(() => {
        getCategorias();
        
        fetchPosts();
        console.log(posts)
    }, [skip,query]);
    const handleChangeAddress = (event) => {
        setAddress1(event.target.value)
        setSkip(0)
        newFetchPostsAddress(event.target.value);
    }
    async function newInquiry(e){
        history("/new-inquiry",{state:{stuff:"new"}})
    }

    async function editInquiry(post){
        history("/edit-inquiry",{state:{stuff:"new", post}})
    }

    

    const fetchPosts = async () => {
        if(query.trim()){
            try {
                const response = await read(skip,query,searchThis,address1,statusnya,khusus);
                console.log(response); // log the entire response
                const { data, error } = response;
                if (error) {
                    console.log(error.message);
                    return;
                }
                console.log("data: "+data);
                const yoyo = data;
                console.log(yoyo);
            
                if (data?.length === 0) {
                    setIsEnd("Selesai...");
                    return;
                }
            
                Array.isArray(yoyo) ? setPosts([...posts, ...yoyo]) : console.error('yoyo is not an array:', yoyo);
            } catch (error) {
                console.log(error);
            }
            
            
        }else{

            try{
                const res = await readEmpty(skip,query,searchThis,address1,statusnya,khusus);
                console.log(res); // print the entire response
                const data = res;  // assign the response to data directly
                
                if(data?.length === 0){
                    setIsEnd("Selesai...");
                    return;
                }
            
                //success
                setPosts([...posts, ...data])
            }catch(error){
                console.log(error.message);
            }
            
        }
    }

    const [fileURL, setFileURL] = useState("");


    const previewPDF = async (post) => {
        console.log("diatas")
        setCurrPreview(post)
        setLoadVisibility(true)
        const id = post._id
    
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/renderKontrakVOfromDB`,{
           id 
        }, {
            responseType: "blob"
          }).then(resp => {
                    console.log(resp)
                        const blob = new Blob([resp.data], { type: 'application/pdf' })
                    // saveAs(blob);
                    var fileURLNew = URL.createObjectURL(blob);
                    console.log(fileURLNew)
                    setPreviewVisibility(true)
                    setLoadVisibility(false)
                    setFileURL(fileURLNew)
                })
                

            

        
        
        console.log("2")
    
    }

    const newFetchPosts = async (event) => {
        setPosts([])
        setIsEnd("Loading...");
        if(event.target.value.trim()){
        try{
            const { data, error } = await read(skip,event.target.value, searchThis,address1,statusnya,khusus);
            if(error){

                console.log(error.message);
                return;
            }
            console.log("data: "+data)

            if(data.data?.length === 0){
                setIsEnd("Selesai...");
                return;
            }
            const yoyo = data.data
            //success
            setPosts([...yoyo])
        }catch(error){
            console.log(error.message);
        }
        }else{
            console.log("empty")
            try{
                const { data, error } = await readEmpty(skip,event.target.value,searchThis,address1,statusnya,khusus);
                if(error){
                    console.log(error.message);
                    return;
                }
    
                if(data?.length === 0){
                    setIsEnd("Selesai...");
                    return;
                }
                
                //success
                setPosts([...posts, ...data])
            }catch(error){
                console.log(error.message);
            } 
        }
    }

    const newFetchPostsStat = async (event) => {
        setPosts([])
        setIsEnd("Loading...");
        if(query.trim()){
        try{
            console.log(event)
                const response = await read(skip,query,searchThis,address1,event,khusus);
                const { data, error } = response;
                if (error) {
                    console.log(error.message);
                    return;
                }
                console.log(data);
                const yoyo = data;
                console.log(yoyo);
            
                if (data?.length === 0) {
                    setIsEnd("Selesai...");
                    return;
                }
                setPosts([...yoyo])
        }catch(error){
            console.log(error.message);
        }
        }else{
            
            console.log("empty")
            
            try{
                console.log(event)
                const response = await readEmpty(skip,query,searchThis,address1,event, khusus);
                const { data, error } = response;
                if (error) {
                    console.log(error.message);
                    return;
                }
                console.log(response);
                const yoyo = response;
                console.log(response);
            
                if (response?.length === 0) {
                    setIsEnd("Selesai...");
                    return;
                }
                setPosts([...yoyo])

            }catch(error){
                console.log(error.message);
            } 
        }
    }

    const newFetchPostsKhusus = async (event) => {
        setPosts([])
        setIsEnd("Loading...");
        if(query.trim()){
        try{
            console.log(event)
                const response = await read(skip,query,searchThis,address1,statusnya,event);
                const { data, error } = response;
                if (error) {
                    console.log(error.message);
                    return;
                }
                console.log(data);
                const yoyo = data;
                console.log(yoyo);
            
                if (data?.length === 0) {
                    setIsEnd("Selesai...");
                    return;
                }
                setPosts([...yoyo])
        }catch(error){
            console.log(error.message);
        }
        }else{
            
            console.log("empty")
            
            try{
                console.log(event)
                const response = await readEmpty(skip,query,searchThis,address1,statusnya,event);
                const { data, error } = response;
                if (error) {
                    console.log(error.message);
                    return;
                }
                console.log(response);
                const yoyo = response;
                console.log(response);
            
                if (response?.length === 0) {
                    setIsEnd("Selesai...");
                    return;
                }
                setPosts([...yoyo])

            }catch(error){
                console.log(error.message);
            } 
        }
    }


    const newFetchPostsSearchThis = async (event) => {
        setPosts([])
        setIsEnd("Loading...");
        if(query.trim()){
        try{
            console.log(event)
                const response = await read(skip,query,event,address1,statusnya, khusus);
                const { data, error } = response;
                if (error) {
                    console.log(error.message);
                    return;
                }
                console.log(data);
                const yoyo = data;
                console.log(yoyo);
            
                if (data?.length === 0) {
                    setIsEnd("Selesai...");
                    return;
                }
                setPosts([...yoyo])
        }catch(error){
            console.log(error.message);
        }
        }else{
            
            console.log("empty")
            
            try{
                console.log(event)
                const response = await readEmpty(skip,query,event,address1,statusnya,khusus);
                const { data, error } = response;
                if (error) {
                    console.log(error.message);
                    return;
                }
                console.log(response);
                const yoyo = response;
                console.log(response);
            
                if (response?.length === 0) {
                    setIsEnd("Selesai...");
                    return;
                }
                setPosts([...yoyo])

            }catch(error){
                console.log(error.message);
            } 
        }
    }

    const newFetchPostsAddress = async (event) => {
        setPosts([])
        setIsEnd("Loading...");
        if(query.trim()){
        try{
            console.log(event)
                const response = await read(skip,query,searchThis,event,statusnya,khusus);
                const { data, error } = response;
                if (error) {
                    console.log(error.message);
                    return;
                }
                console.log(data);
                const yoyo = data;
                console.log(yoyo);
            
                if (data?.length === 0) {
                    setIsEnd("Selesai...");
                    return;
                }
                setPosts([...yoyo])
        }catch(error){
            console.log(error.message);
        }
        }else{
            
            console.log("empty")
            
            try{
                console.log(event)
                const response = await readEmpty(skip,query,searchThis,event,statusnya,khusus);
                const { data, error } = response;
                if (error) {
                    console.log(error.message);
                    return;
                }
                console.log(response);
                const yoyo = response;
                console.log(response);
            
                if (response?.length === 0) {
                    setIsEnd("Selesai...");
                    return;
                }
                setPosts([...yoyo])

            }catch(error){
                console.log(error.message);
            } 
        }
    }
    const ColorButton = styled(Button)(({ theme }) => ({
        color: theme.palette.getContrastText(purple[500]),
        backgroundColor: purple[500],
        '&:hover': {
          backgroundColor: purple[700],
        },
      }));

    const handleScroll = (e) => {
        const { offsetHeight, scrollTop, scrollHeight } = e.target;

        if(offsetHeight + scrollTop >= scrollHeight){
            setSkip(posts?.length);
        }
    }
    const [searchThis, setsearchThis]= useState("Perusahaan");
    const handleSearch = (event) =>{
        console.log("newFetchPosts")

        setQuery(event.target.value)
        setSkip(0)
        newFetchPosts(event)
    }

    const handleClosePreview = (event) =>{
        setPreviewVisibility(false)
        setCurrPreview("none")
    }
    const history = useNavigate();

    const editPI = async (post) => {
        if(currPreview === "none"){
            history("/create-kontrak",{state:{data:post, stuff:"edit"}})
        }else{
            history("/create-kontrak",{state:{data:currPreview, stuff:"edit"}})
        }
    }

    const extend = async (post)=>{
        if(currPreview === "none"){
            history("/create-kontrak", {state:{data:post,stuff:"extend"}})
        }else{
            history("/create-kontrak", {state:{data:currPreview,stuff:"extend"}})
        }
    }

    const [openSignature,setOpenSignature] = useState(false);
    const closeOpenSignature = () => {
        setOpenSignature(false)
    }

    const openSignatureNow = () => {
        setOpenSignature(true)

    }

    const [statusnya,setStatusnya] = useState("Aktif");

    const handleChangeStatus = (event) => {
        console.log(event)
        setStatusnya(event.target.value)
        setSkip(0)
        newFetchPostsStat(event.target.value)
        }

    const [khusus, setKhusus] = useState("")

    const handleChangeKhusus = (event) =>{
        console.log(event.target.value)
        setKhusus(event.target.value)
        setSkip(0)
        newFetchPostsKhusus(event.target.value)
    }

    function getContractStatus(startDate, endDate) {
        console.log(startDate + endDate)
        var currentDate = new Date();
        var starting = new Date(startDate)
        var ending = new Date(endDate)
        if (currentDate < starting) {
          return 'Belum Mulai';  // Not Started
        } else if (currentDate >= starting && currentDate <= ending) {
          return 'Aktif';  // Active
        } else if (currentDate > ending) {
          return 'Expired';  // Inactive
        }
      }

      const changeSearchThis = (event)=>{
        console.log(event)
        setsearchThis(event)
        setSkip(0)
        newFetchPostsSearchThis(event)
      }

      const [useData, setUseData] = useState()
      const [openNewMail, setOpenNewMail] = useState(false)
      const [check,setCheck] = useState()
      const newMail = (post) => {
        setUseData(post);
        setOpenNewMail(true)

      }

      const closeNewMail = () => {
        setOpenNewMail(false)
      }
      const [selected, setSelected] = useState(null);
      const times = Array.from({length: 48}, (_, i) => {
        const hour = Math.floor(i/2);
        const minute = i%2 === 0 ? '00' : '30';
        const nextHour = Math.floor((i+1)/2);
        const nextMinute = (i+1)%2 === 0 ? '00' : '30';
        return `${hour.toString().padStart(2, '0')}:${minute}-${nextHour.toString().padStart(2, '0')}:${nextMinute}`;
      });
      const rooms = ['VIP Meeting Room 1', 'VIP Meeting Room 2']; // Extend this list to cover all rooms
    
      const handleCellClick = (roomIndex, timeIndex) => {
        setSelected({ roomIndex, timeIndex });
      };
      const [openTamu,setOpenTamu]=useState(false)
    return <Grid container>
                <Dialog open={openNewMail} onClose={closeNewMail} maxWidth={"xl"}>
                    <NewBookingPopUp setCheck={setCheck} check={check} useData={useData} searchThis={searchThis} closeNewMail={closeNewMail}></NewBookingPopUp>
                </Dialog>
                <Dialog open={openTamu} onClose={(event)=>setOpenTamu(false)} maxWidth={"xl"}>
                    <TamuBooking></TamuBooking>
                </Dialog>
                <Dialog open={loadVisibility} aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "100px",  // Set your width here
                        },
                    },}}>
                    <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <LinearProgress />
                    </Box>
                    </DialogContent>
                </Dialog>
                <Grid item  xl={0.5} lg={0.7} md={0.9} sm={3.2} className="leftmenucolor">
                    <LeftMenu/>
                </Grid>
                <Grid xl={10.8} lg={10.6} md={10.4} sm={8.8} >
                <Dialog
                    open={previewVisibility}
                    onClose={handleClosePreview}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "1250px",  // Set your width here
                        },
                    },}}
                                >
                    <DialogTitle id="alert-dialog-title">
                        <Button onClick={handleClosePreview} autoFocus>
                            <CloseIcon></CloseIcon>
                        </Button>
                    </DialogTitle>
                    <DialogContent>
                    <iframe src={fileURL} width="100%" height="500" style={{zoom:"150%"}}/>
                    <DialogContentText id="alert-dialog-description">
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                    <Button variant="contained" color="error" style={{ marginRight: 'auto' }}>
                        Batal Kontrak
                    </Button>
                    <Button onClick={() => editPI()}>
                        <EditIcon></EditIcon>
                    </Button>
                    <ColorButton variant="contained" onClick={openSignatureNow}>Upload Tanda Tangan</ColorButton>
                    <Button onClick={() => extend()} variant="contained" color="success">
                        Extend
                    </Button>
                    </DialogActions>
                </Dialog>
                <Grid className="boxshadowclass" position="fixed" width="98%" xs={12} zIndex="100" opacity="1">
                <Header judul="Booking Meeting Room" isi="Mau Booking Meeting Room? Cari nama Perusahan yang Booking"></Header>
                    </Grid>
                    <Grid sx={{ mt:15}}></Grid>
                    <Grid sx={{ pl:15}}>
                        <Grid container xs={12} sx={{mb:10}}>
                                
                            <Grid item xs={4} >
                                <Typography><b>Lokasi:</b></Typography>
                                <Select value={address1} error={alamatStatus} helperText={alamatMessage} whiteSpace="normal" onChange={event => handleChangeAddress(event)}>{categorias.map((categoria) =><MenuItem multiline value={categoria}>{categoria}</MenuItem>)}<MenuItem multiline value="semua">Semua Lokasi</MenuItem></Select>
                            </Grid>
                            <Grid item xs={4} >
                                <Typography><b>Tipe Kontrak:</b></Typography>
                                <FormControl component="fieldset">
                                <RadioGroup value={khusus} onChange={event => handleChangeKhusus(event)}>
                                    <FormControlLabel value="" control={<Radio />} label="Semua" />
                                    <FormControlLabel value="Virtual Office" control={<Radio />} label="Virtual Office Only" />
                                    <FormControlLabel value="Private Office" control={<Radio />} label="Private Office Only" />
                                </RadioGroup>
                                </FormControl>
                                </Grid>
                            
                        </Grid>
                            <Grid container sx={{mb:2}} alignItems="center">
                                <Grid item xs={2}>
                                    <Select fullWidth value={searchThis} onChange={event => changeSearchThis(event.target.value)}>
                                        <MenuItem value="Perusahaan">Nama PT</MenuItem>
                                        <MenuItem value="Klien">Nama Klien</MenuItem>
                                    </Select>
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField value={query} onChange={event => handleSearch(event)} fullWidth />
                                </Grid>
                                <Grid item xs={4} container justifyContent="flex-end">
                                    <Button variant="contained" sx={{height: '60px'}} onClick={(event)=>setOpenTamu(true)}>Booking Tamu/Guests</Button>
                                </Grid>
                            </Grid>

                            <Grid container align = "center" justify = "center" alignItems = "center">
                            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                                <TableContainer sx={{ maxHeight: 500, minHeight: 440 }} className="min-h-screen h-screen overflow-scroll" onScroll={handleScroll}>
                                    <Table stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                    Nama Perusahaan
                                                </TableCell>
                                                <TableCell>
                                                    Nama Klien
                                                </TableCell>
                                                <TableCell>
                                                    Tipe Kontrak
                                                </TableCell>
                                                <TableCell>
                                                    Status
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        {posts?.map((post) => (
                                            <TableBody>
                                                <TableRow hover onClick={()=> newMail(post)}>
                                                    <TableCell onClick={()=> newMail(post)} style={{cursor:'pointer'}}>
                                                        <p>{post.company?.namaPerusahaan?? ""}</p>
                                                    </TableCell>
                                                    <TableCell onClick={()=> newMail(post)} style={{cursor:'pointer'}}>
                                                        <p>{post.klien?.Nama??""}</p>
                                                    </TableCell>
                                                    <TableCell onClick={()=> newMail(post)} style={{cursor:'pointer'}}>
                                                        <p>{post.kontrak?.TipeKontrak??""}</p>
                                                    </TableCell>
                                                    <TableCell onClick={()=> newMail(post)} style={{cursor:'pointer'}}>
                                                    <p>{getContractStatus(post.kontrak?.TanggalMulai??"", post.kontrak?.TanggalBerakhir??"")}</p> {/* replace with status */}                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        ))}
                                        {isEnd}
                                    </Table>
                                </TableContainer>
                            </Paper>
                                
                            </Grid>
                            
                            
                    </Grid>
                </Grid>    
            </Grid>
    };